import { render, staticRenderFns } from "./exercise_answer_result.vue?vue&type=template&id=261ca6e5"
import script from "./exercise_answer_result.vue?vue&type=script&lang=js"
export * from "./exercise_answer_result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports